import React, { useState, useEffect } from 'react';
import "jspdf-autotable";
import { useNavigate } from 'react-router-dom';
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';

import TempListMaster from '../../TempListMaster';
import CreateEditWarehouseLocation from './CreateEditWarehouseLocation';
import ApiService, { userCode, username } from '../../../../services/ApiService';
import { Backdrop } from '@mui/material';
import LoadingSpinner from '../../../../components/Components/LoadingSpinner';
import CustomToastContainer, { showToast } from '../../../../components/ui';

const WarehouseLocationList = forwardRef((props, ref) => {
    const [isLoadingBackDrop, setIsLoadingBackDrop] = useState(true);
    const [data, setData] = useState([]);
    const [titleModal, setTitleModal] = useState('');
    const title = 'Warehouse Location'
    const [isModal, setIsModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [dataMap, setDataMap] = useState([])
    const [columnData, setColumnData] = useState([])
    const [SelectedData, setSelectedData] = useState({});
    const [totalRows, setTotalRows] = useState(50)
    const history = useNavigate()
    const [rowsCount, setRowsCount] = useState(50)
    const [numPage, setNumPage] = useState(1)
    const [filter, setFilter] = useState([])
    const [filterBy, setFilterBy] = useState([])

    const param = "warehouse/warehouselocation/warehouselocation";
    const paramWarehouse = "warehouse/warehouses/warehouses";
    const [id, setId] = useState(0);
    const [code, setCode] = useState('');
    const [name, setName] = useState('');
    const [locationX, setLocationX] = useState('');
    const [locationY, setLocationY] = useState('');
    const [locationZ, setLocationZ] = useState('');
    const [warehouseId, setWarehouseId] = useState('');
    const [warehouseName, setWarehouseName] = useState('');
    const [warehouseLocationTypeId, setWarehouseLocationTypeId] = useState('');
    const [warehouseLocationTypeName, setWarehouseLocationTypeName] = useState('');
    const [isRack, setIsRack] = useState(false);
    const [isAvailable, setIsAvailable] = useState('');
    const [stateX, setStateX] = useState({});
    const [sortArr, setSortArr] = useState([])

    let countErr = 0

    const dataLocal = JSON.parse(localStorage.getItem(username + "-DataWarehouseLocation"));

    const simpanLocal = () => {
        if (isModal) {
            var data;
            data =
            {
                "warehouselocation": {
                    "rowStatus": "ACT",
                    "id": id,
                    "code": code,
                    "name": name,
                    "locationX": locationX,
                    "locationY": locationY,
                    "locationZ": locationZ,
                    "warehouseId": warehouseId,
                    "warehouseName": warehouseName,
                    "warehouseLocationTypeId": warehouseLocationTypeId,
                    "warehouseLocationTypeName": warehouseLocationTypeName,
                    "isRack": isRack,
                    "isAvailable": isAvailable,
                    "userCode": userCode,
                    "titleModal": titleModal
                }
            }
            localStorage.setItem(username + "-DataWarehouseLocation", JSON.stringify(data));
        }
    }

    useImperativeHandle(ref, () => ({

        localSave() {
            simpanLocal()
        }

    }));

    const fetchDataLocal = () => {
        var result = dataLocal.warehouselocation;
        setIsModal(true);
        setCode(result.code);
        setName(result.name);
        setLocationX(result.locationX);
        setLocationY(result.locationY);
        setLocationZ(result.locationZ);
        setWarehouseId(result.warehouseId);
        setWarehouseName(result.warehouseName);
        setWarehouseLocationTypeId(result.warehouseLocationTypeId);
        setWarehouseLocationTypeName(result.warehouseLocationTypeName);
        setIsRack(result.isRack);
        setIsAvailable(result.isAvailable);
        setId(result.id);
        setTitleModal(result.titleModal);
        localStorage.removeItem(username + '-DataWarehouseLocation')
    }


    const toggleAdd = () => {
        setId(0);
        setCode('');
        setName('');
        setLocationX('');
        setLocationY('');
        setLocationZ('');
        setWarehouseId('');
        setWarehouseName('');
        setWarehouseLocationTypeId('');
        setWarehouseLocationTypeName('');
        setIsRack('');
        setIsAvailable('');
        handleClick();
        setTitleModal('Add');
    }

    const toggleEdit = () => {
        if (SelectedData.id === undefined) {
            showToast({ type: 'error', message: 'Please Select Data!' })
        } else {
            setId(SelectedData.id);
            setCode(SelectedData.code);
            setName(SelectedData.name);
            setLocationX(SelectedData.locationX);
            setLocationY(SelectedData.locationY);
            setLocationZ(SelectedData.locationZ);
            setWarehouseId(SelectedData.warehouseId);
            setWarehouseLocationTypeId(SelectedData.warehouseLocationTypeId);
            setWarehouseLocationTypeName(SelectedData.warehouseLocationTypeName);
            setIsRack(SelectedData.isRack);
            setIsAvailable(SelectedData.isAvailable);
            setIsModal(true);
            setTitleModal('Edit');
            ApiService.PostById(paramWarehouse, SelectedData.warehouseId)
                .then((res) => {
                    setWarehouseName(res.data.data.warehouses.name);
                })
        }
    }

    let countRefresh = 0;

    useEffect(() => {
        if (countRefresh === 0) {
            ApiService.refreshToken();
            countRefresh++;
            if (dataLocal) {
                setTimeout(function () { fetchDataLocal(); }, 2000);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getData = (pageNumber, pageSize, filters, orderBy) => {
        if (isLoadingBackDrop === false) {
            setIsLoading(true);
        } else {
            setIsLoadingBackDrop(true);
        }
        ApiService.DynamicPostByPage(param, 'PAGE', pageNumber, pageSize, [], filters, orderBy)
            .then((response) => {
                if (response.data.code === 200) {
                    setSelectedData({})
                    setData(response.data.data.warehouseLocation);

                    let temp = response.data.data.warehouseLocation
                    let indexed = temp.map((el, index) => {
                        let indexedTemp = {
                            ...el,
                            index
                        }
                        return indexedTemp
                    })

                    setDataMap(indexed)
                    setColumnData(response.data.data.columns)
                    setTotalRows(response.data.totalRowCount)

                    setIsLoading(false)
                    setIsLoadingBackDrop(false)
                } else {
                    setIsLoading(false)
                    setIsLoadingBackDrop(false)
                }
                setIsLoading(false)
            })
            .catch(function (error) {
                setIsLoading(false)
                setIsLoadingBackDrop(false)
                console.error('error saat fetch', error)
                countErr++
                if (countErr < 3) {
                    getData(1, 50)
                } else {
                    ApiService.logOut()
                    history('/')
                }
            })
    }

    const handleClick = () => {
        if (isModal === false) {
            setIsModal(true);
        } else {
            setIsModal(false);
            setNumPage(1)
            setRowsCount(50)
            setId(0);
            setCode('');
            setName('');
            setLocationX('');
            setLocationY('');
            setLocationZ('');
            setWarehouseId('');
            setWarehouseName('');
            setWarehouseLocationTypeId('');
            setWarehouseLocationTypeName('');
            setIsRack('');
        }
    };

    function CellDoubleClick(row) {
        toggleEdit()
    }

    return (
        <>
            <CustomToastContainer />
            <TempListMaster
                SelectedData={SelectedData}
                param={param}
                data={data}
                title={title}
                toggleAdd={toggleAdd}
                toggleEdit={toggleEdit}
                isLoading={isLoading}
                getData={getData}
                columnData={columnData}
                dataMap={dataMap}
                setSelectedData={setSelectedData}
                CellDoubleClick={CellDoubleClick}
                totalRows={totalRows}
                rowsCount={rowsCount}
                setRowsCount={setRowsCount}
                numPage={numPage}
                setNumPage={setNumPage}
                filter={filter}
                setFilter={setFilter}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                stateX={stateX}
                setStateX={setStateX}
                menuCode={'MWHWHL'}
                sortArr={sortArr}
                setSortArr={setSortArr}
            />

            {
                isModal && (
                    <CreateEditWarehouseLocation
                        isModal={isModal}
                        titleModal={titleModal}
                        handleClick={handleClick}
                        title={title}
                        param={param}
        
                        id={id}
                        code={code}
                        setCode={setCode}
                        name={name}
                        setName={setName}
                        locationX={locationX}
                        setLocationX={setLocationX}
                        locationY={locationY}
                        setLocationY={setLocationY}
                        locationZ={locationZ}
                        setLocationZ={setLocationZ}
                        warehouseId={warehouseId}
                        setWarehouseId={setWarehouseId}
                        warehouseName={warehouseName}
                        setWarehouseName={setWarehouseName}
                        warehouseLocationTypeId={warehouseLocationTypeId}
                        setWarehouseLocationTypeId={setWarehouseLocationTypeId}
                        warehouseLocationTypeName={warehouseLocationTypeName}
                        setWarehouseLocationTypeName={setWarehouseLocationTypeName}
                        isRack={isRack}
                        setIsRack={setIsRack}
                        isAvailable={isAvailable}
                        setIsAvailable={setIsAvailable}
        
                        getData={getData}
                    />
                )
            }

            {
                isLoadingBackDrop && (
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={isLoadingBackDrop}
                    >
                        <LoadingSpinner />
                    </Backdrop>
                )
            }
        </>
    )
})

export default WarehouseLocationList